module.exports = new __parcel__URL__("her.a136dc86.jpg").toString();